export default __webpack_public_path__ + "static/media/Marker-Icon-Bg-White.c2736cff.png";